import { useLanguage } from "../i18n";

export const Footer = ({ onPrivacy }) => {
  const { t } = useLanguage();
  return (
    <footer className="border-t border-white/5 py-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <div>
            <p className="font-display font-semibold tracking-tight">Luca Pedano</p>
            <p className="font-mono text-[11px] text-white/35">{t.footer.made}</p>
          </div>
        </div>
        <div className="flex flex-col md:items-end gap-2">
          <button onClick={onPrivacy} data-testid="footer-privacy-link" className="font-mono text-[11px] text-white/40 underline underline-offset-4 hover:text-brand-cyan transition-colors duration-300">
            Privacy & Cookie Policy
          </button>
          <p className="font-mono text-[11px] text-white/30" data-testid="footer-copyright">
            © {new Date().getFullYear()} Luca Pedano — {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
};
